import React from "react";
import ParagraphTag from "./Paragraph";
import { Ruler, Trash } from "lucide-react";

const UnitsCard = (props) => {
  const { data, classes, onTrigger, isDelete } = props;
  return (
    <div
      className={`${classes} bg-slate-100 flex justify-between items-center rounded-md relative `}
      onClick={onTrigger}
    >
      <div className="w-[78%] pl-3">
        <ParagraphTag
          content={data?.unitName}
          classes={`text-darkColor font-popinsSemiBold text-sm`}
        />
        <div className="flex pt-2">
          <div className="flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              viewBox="0 0 18 21"
              fill="none"
            >
              <path
                d="M11.5 2.375H6.5C6.14844 2.375 5.875 2.6875 5.875 3V9.25H4V3C4 1.63281 5.09375 0.5 6.5 0.5H11.5C12.8672 0.5 14 1.63281 14 3V9.25H12.125V3C12.125 2.6875 11.8125 2.375 11.5 2.375ZM2.75 6.4375V8.9375C2.75 9.48438 2.32031 9.875 1.8125 9.875C1.26562 9.875 0.875 9.48438 0.875 8.9375V6.4375C0.875 5.92969 1.26562 5.5 1.8125 5.5C2.32031 5.5 2.75 5.92969 2.75 6.4375ZM17.125 6.4375V8.9375C17.125 9.48438 16.6953 9.875 16.1875 9.875C15.6406 9.875 15.25 9.48438 15.25 8.9375V6.4375C15.25 5.92969 15.6406 5.5 16.1875 5.5C16.6953 5.5 17.125 5.92969 17.125 6.4375ZM9.9375 16.125V18.625H11.8125C12.3203 18.625 12.75 19.0547 12.75 19.5625C12.75 20.1094 12.3203 20.5 11.8125 20.5H9H6.1875C5.64062 20.5 5.25 20.1094 5.25 19.5625C5.25 19.0547 5.64062 18.625 6.1875 18.625H8.0625V16.125H3.25781C2.28125 16.125 1.5 15.3438 1.5 14.3672C1.5 14.1328 1.53906 13.9375 1.57812 13.7422L2.35938 11.75C2.63281 11.0078 3.33594 10.5391 4.11719 10.5391H13.8828C14.6641 10.5391 15.3281 11.0078 15.6016 11.75L16.3828 13.7422C16.4609 13.9375 16.5 14.1328 16.5 14.3672C16.5 15.3438 15.6797 16.125 14.7031 16.125H9.9375ZM4.11719 12.375L3.41406 14.25H9H14.5469L13.8438 12.375H4.11719Z"
                fill="#FF814E"
              />
            </svg>
            <ParagraphTag
              content={data?.offices}
              classes={`text-darkColor font-popinsRegular pl-1 text-xs`}
            />
          </div>
          <div className="flex px-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              viewBox="0 0 19 21"
              fill="none"
            >
              <path
                d="M0.701172 1.4375C0.701172 0.929688 1.0918 0.5 1.63867 0.5H2.88867H16.0137H17.2637C17.7715 0.5 18.2012 0.929688 18.2012 1.4375C18.2012 1.98438 17.7715 2.375 17.2637 2.375H16.0137H2.88867H1.63867C1.0918 2.375 0.701172 1.98438 0.701172 1.4375ZM3.86523 7.64844C5.34961 7.21875 7.3418 7.0625 9.45117 7.0625C11.5215 7.0625 13.5137 7.21875 14.998 7.64844L15.0762 7.6875V3.625H16.9512V8.625C17.498 9.09375 17.8887 9.71875 17.8887 10.5C17.8887 13.3516 16.5605 15.2266 14.8027 16.3203C14.7246 16.3594 14.6855 16.3984 14.6074 16.4375L15.4668 18.0391C15.623 18.2734 15.7012 18.5469 15.7012 18.8203C15.7012 19.7578 14.9199 20.5 13.9824 20.5H4.88086C3.94336 20.5 3.20117 19.7578 3.20117 18.8203C3.20117 18.5469 3.24023 18.2734 3.39648 18.0391L4.25586 16.4375C4.17773 16.3984 4.13867 16.3594 4.06055 16.3203C2.30273 15.2266 1.01367 13.3516 1.01367 10.5C1.01367 9.71875 1.36523 9.09375 1.91211 8.625H1.95117V3.625H3.82617V7.6875L3.86523 7.64844ZM15.2715 13.2734C15.1934 13.3125 15.0762 13.3516 14.998 13.3906C13.5137 13.7812 11.5215 13.9375 9.45117 13.9375C7.3418 13.9375 5.34961 13.7812 3.86523 13.3906C3.78711 13.3516 3.66992 13.3125 3.5918 13.2734C3.98242 13.8984 4.49023 14.3672 5.03711 14.7188C6.36523 15.5391 8.04492 15.8125 9.45117 15.8125C10.8184 15.8125 12.5371 15.5391 13.8262 14.7188C14.373 14.3672 14.9199 13.8984 15.2715 13.2734ZM2.88867 10.5C2.88867 10.6562 2.92773 10.8125 3.12305 10.9688C3.35742 11.2031 3.78711 11.3984 4.37305 11.5547C5.62305 11.9062 7.38086 12.0625 9.45117 12.0625C11.4824 12.0625 13.2402 11.9062 14.4902 11.5938C15.0762 11.3984 15.5059 11.2031 15.7402 11.0078C15.9355 10.8125 15.9746 10.6562 15.9746 10.5391C15.9746 10.3828 15.9355 10.2266 15.7402 10.0703C15.5059 9.83594 15.0762 9.64062 14.4902 9.48438C13.2402 9.09375 11.4824 8.9375 9.45117 8.9375C7.38086 8.9375 5.62305 9.09375 4.37305 9.44531C3.78711 9.64062 3.35742 9.83594 3.12305 10.0312C2.92773 10.2266 2.88867 10.3828 2.88867 10.5ZM12.8887 17.1797C11.6777 17.5703 10.4668 17.6875 9.45117 17.6875C8.39648 17.6875 7.18555 17.5703 5.97461 17.1797L5.19336 18.625H13.6699L12.8887 17.1797ZM5.70117 3.625H7.57617C7.88867 3.625 8.20117 3.9375 8.20117 4.25C8.20117 4.60156 7.88867 4.875 7.57617 4.875H5.70117C5.34961 4.875 5.07617 4.60156 5.07617 4.25C5.07617 3.9375 5.34961 3.625 5.70117 3.625Z"
                fill="#FF814E"
              />
            </svg>
            <ParagraphTag
              content={data?.bathrooms}
              classes={`text-darkColor font-popinsRegular pl-1 text-xs `}
            />
          </div>
          <div className="flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              viewBox="0 0 16 21"
              fill="none"
            >
              <path
                d="M11.6914 0.5C12.4336 0.5 12.9805 1.24219 12.7852 1.94531L10.6758 9.25H14.0352C14.7773 9.25 15.3633 9.875 15.3633 10.6172C15.3633 11.0469 15.207 11.3984 14.8945 11.6719L4.77734 20.2656C4.58203 20.4219 4.34766 20.5 4.07422 20.5C3.33203 20.5 2.78516 19.7969 2.98047 19.0938L5.08984 11.75H1.69141C0.988281 11.75 0.402344 11.1641 0.402344 10.4609C0.402344 10.0703 0.558594 9.71875 0.832031 9.44531L10.9883 0.773438C11.1836 0.617188 11.418 0.5 11.6914 0.5ZM10.2852 3.82031L3.21484 9.875H6.33984C6.61328 9.875 6.88672 10.0312 7.08203 10.2656C7.23828 10.5 7.31641 10.8125 7.23828 11.0859L5.48047 17.2188L12.6289 11.125H9.46484C9.15234 11.125 8.87891 11.0078 8.68359 10.7734C8.52734 10.5391 8.44922 10.2266 8.52734 9.95312L10.2852 3.82031Z"
                fill="#FF814E"
              />
            </svg>
            <ParagraphTag
              content={`${data?.electric} `}
              classes={`text-darkColor font-popinsRegular pl-1 text-xs `}
            />
          </div>
          <div className="flex pl-3">
            <Ruler className="text-themeColor" size={18} strokeWidth={2} />
            <ParagraphTag
              content={`${data?.size} sqft`}
              classes={`text-darkColor font-popinsRegular pl-1 text-xs `}
            />
          </div>
        </div>
      </div>
      <div className="w-[22%] text-end pr-3">
        <ParagraphTag
          content={`$ ${data?.rent}`}
          classes={`text-themeColor font-popinsSemiBold text-base `}
        />
        <ParagraphTag
          content={`/${data?.rentType}`}
          classes={`text-darkColor/40 font-popinsRegular text-xs`}
        />
      </div>
      {isDelete && (
        <div className="w-5 h-5 rounded-md flex justify-center items-center absolute right-0 top-[-8px]">
          <Trash color="#E43B3B" size={14} />
        </div>
      )}
    </div>
  );
};

export default UnitsCard;
